"use strict";
(globalThis["webpackChunktvg_shopify_theme"] = globalThis["webpackChunktvg_shopify_theme"] || []).push([[5630],{

/***/ 930:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6466);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6361);
/* harmony import */ var _core_shopify_init_section_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8711);



const NAMESPACE = '.js-tabbed-showcase-section';
(0,_core_shopify_init_section_index_js__WEBPACK_IMPORTED_MODULE_2__.initSection)('.js-tabbed-showcase-section', (_section)=>{
    const section = jquery__WEBPACK_IMPORTED_MODULE_0___default()(_section);
    const videoElements = jquery__WEBPACK_IMPORTED_MODULE_0___default()(NAMESPACE).find('.js-video video');
    videoElements.prop('controls', false);
    const active = 'active';
    const activeTab = 'TabbedSlideshow-tabActive';
    const swiperInstances = {};
    const initializeSwiper = (tabID)=>{
        const slideshowContainer = section.find(`.js-swiper-${tabID}`).first();
        const slideshowContainerElement = slideshowContainer.get(0);
        if (slideshowContainerElement) {
            const swiper = new swiper__WEBPACK_IMPORTED_MODULE_1__["default"](slideshowContainerElement, {
                modules: [
                    swiper__WEBPACK_IMPORTED_MODULE_1__.Navigation,
                    swiper__WEBPACK_IMPORTED_MODULE_1__.Scrollbar
                ],
                direction: 'horizontal',
                slidesPerView: 1.15,
                spaceBetween: 32,
                loop: false,
                slidesOffsetAfter: 16,
                scrollbar: {
                    el: `.${'TabbedSlideshow-swiperSrollbar'}`,
                    draggable: true
                },
                breakpoints: {
                    800: {
                        slidesPerView: 3.25,
                        spaceBetween: 48,
                        slidesOffsetAfter: 0
                    }
                },
                init: false
            });
            swiper.init();
            swiperInstances[tabID] = swiper;
        }
    };
    // Initialize both sliders
    initializeSwiper('1');
    initializeSwiper('2');
    const showTabContent = (tabID)=>{
        Object.keys(swiperInstances).forEach((key)=>{
            const swiper = swiperInstances[key];
            if (swiper) {
                swiper.destroy();
                swiperInstances[key] = null;
            }
        });
        initializeSwiper(tabID);
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(`.${'TabbedSlideshow'}`).removeClass(active);
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(`.${'TabbedSlideshow'}[id="${tabID}"]`).addClass(active);
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(`.${'TabbedSlideshow-tab'}`).removeClass(activeTab);
        jquery__WEBPACK_IMPORTED_MODULE_0___default()(`.${'TabbedSlideshow-tab'}[data-slider-id="${tabID}"]`).addClass(activeTab);
    };
    section.on('click' + NAMESPACE, `.${'TabbedSlideshow-tab'}`, function(evt) {
        evt.preventDefault();
        const targetTab = jquery__WEBPACK_IMPORTED_MODULE_0___default()(evt.currentTarget);
        const targetTabID = targetTab.attr('data-slider-id');
        if (typeof targetTabID === 'string') {
            showTabContent(targetTabID);
        }
    });
    section.on('click' + NAMESPACE, '.js-swiper-arrow', function(evt) {
        evt.preventDefault();
        const action = jquery__WEBPACK_IMPORTED_MODULE_0___default()(evt.currentTarget).attr('data-action');
        const swiperAction = action === 'prev' ? 'slidePrev' : 'slideNext';
        const activeTabID = jquery__WEBPACK_IMPORTED_MODULE_0___default()(NAMESPACE).find(`.${activeTab}`).attr('data-slider-id');
        if (activeTabID && swiperInstances[activeTabID]) {
            const swiper = swiperInstances[activeTabID];
            swiper === null || swiper === void 0 ? void 0 : swiper.slideTo(swiper.activeIndex + (swiperAction === 'slideNext' ? 1 : -1));
        }
    });
    section.on('click' + NAMESPACE, '.js-video', function(evt) {
        evt.preventDefault();
        const target = evt.currentTarget;
        const videoElem = target.querySelector('video');
        const videoPlayElem = target.querySelector('.js-video-play');
        if (videoElem instanceof HTMLVideoElement) {
            if (videoElem.paused) {
                videoPlayElem.style.display = 'none';
                videoElem.play();
                videoElem.controls = true;
            } else {
                videoPlayElem.style.display = 'block';
                videoElem.pause();
                videoElem.controls = false;
            }
        }
    });
    return {
        unload: ()=>{
            section.off(NAMESPACE);
            Object.keys(swiperInstances).forEach((key)=>{
                const swiper = swiperInstances[key];
                if (swiper) {
                    swiper.destroy();
                    swiperInstances[key] = null;
                }
            });
        },
        selectBlock: (block)=>{
            var _block_closest;
            Object.keys(swiperInstances).forEach((key)=>{
                const swiper = swiperInstances[key];
                if (swiper) {
                    swiper.destroy();
                    swiperInstances[key] = null;
                }
            });
            const slideIndex = parseInt(((_block_closest = block.closest('.swiper-slide')) === null || _block_closest === void 0 ? void 0 : _block_closest.getAttribute('data-swiper-slide-index')) || '0', 10);
            if (!isNaN(slideIndex)) {
                const activeTabID = jquery__WEBPACK_IMPORTED_MODULE_0___default()(NAMESPACE).find(`.${activeTab}`).attr('data-slider-id');
                if (activeTabID) {
                    initializeSwiper(activeTabID);
                    const swiper = swiperInstances[activeTabID];
                    if (swiper) {
                        swiper.slideTo(slideIndex);
                    }
                }
            }
            return ()=>{
                Object.keys(swiperInstances).forEach((key)=>{
                    const swiper = swiperInstances[key];
                    if (swiper) {
                        var _swiper_autoplay;
                        (_swiper_autoplay = swiper.autoplay) === null || _swiper_autoplay === void 0 ? void 0 : _swiper_autoplay.start();
                    }
                });
            };
        }
    };
});


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [2333], () => (__webpack_exec__(930)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);